/**
 * Range-aware wrapper around `API.MissionControl.getLogs`. Same idea as cachedRobotDetail: when a
 * caller widens a previously-loaded window for the same operator, we fetch only the gap.
 */

import type { MissionControlLog } from "@domain/missionControl";
import { RangeCache } from "./rangeCache";
import { API } from "./index";

const logCache = new RangeCache<MissionControlLog>({
	timestampOf: (l) => new Date(l.timestamp).getTime(),
	// Mission-control logs occasionally arrive with a stable `id`; dedupe in case overlapping fetches
	// return the same row twice. Falls back to a synthetic key when id is missing.
	keyOf: (l) => (l.id != null ? `id:${l.id}` : `${l.userId}::${l.timestamp}::${l.eventType ?? ""}`),
});

export async function getLogsInRange(user: string, start: Date, end: Date): Promise<MissionControlLog[]> {
	return logCache.query(user, [start.getTime(), end.getTime()], (key, gap) =>
		API.MissionControl.getLogs(key, new Date(gap[0]).toISOString(), new Date(gap[1]).toISOString()),
	);
}

/** Test/debug helper. */
export function __clearMissionControlLogCache(): void {
	logCache.clear();
}
